export default __webpack_public_path__ + "static/media/click.bc1fe20b.wav";